import React, { useRef } from "react";

interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  children: React.ReactNode;
  title?: string;
  className?: string;
}

const ModalNew: React.FC<ModalProps> = ({
  isOpen,
  onClose,
  children,
  className,
}) => {
  const modalRef = useRef<HTMLDivElement>(null);

  if (!isOpen) return null;

  const handleBackdropClick = (e: React.MouseEvent<HTMLDivElement>) => {
    if (modalRef.current && !modalRef.current.contains(e.target as Node)) {
      onClose();
    }
  };

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-[black]/40"
      onMouseDown={handleBackdropClick}
    >
      <div
        ref={modalRef}
        className={`bg-white rounded-[12px] shadow-lg w-full max-w-[486px] mx-4 relative ${className}`}
        onMouseDown={(e) => e.stopPropagation()}
      >
        {/* <button
          className="absolute top-2 right-2 text-gray-500 hover:text-gray-700"
          onClick={onClose}
          aria-label="Close"
        >
          &times;
        </button>
        {title && <div className="px-6 pt-6 pb-2 text-lg font-semibold">{title}</div>} */}
        <div className={`px-2 md:px-5 py-2 md:py-5 ${className}`}>
          {children}
        </div>
      </div>
    </div>
  );
};

export default ModalNew;
